import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PolizzeFormComponent } from './dialogs/form/form.component';
import { PolizzeComponent } from './polizze.component';

const routes: Routes = [
  {
    path: '', component: PolizzeComponent
  },
  {
    path: 'inserisci', component: PolizzeFormComponent,
    data: { title: 'Inserimento Polizze' },
  },
  { path: ':idPolizza', loadChildren: () => import('./view/polizza-view.module').then(m => m.PolizzaViewModule) },

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PolizzeRoutingModule { }
